export enum EXPORT_TYPE {
  INSTANCE,
  SERIES,
  STUDY,
}

export enum IMAGE_TYPE {
  IMAGE,
  DICOM,
  RAW,
}
